// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"53":"merkliste","131":"latest","580":"i18n","732":"configurator2023","791":"video","798":"options","856":"availability","923":"util","926":"locationfinder","930":"reseller","937":"nachfolger"}[chunkId] || chunkId) + "." + __webpack_require__.h() + ".js";
};